import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { ConversationTask } from "@/types";

interface NewTaskStore {
  createdTasks: { [conversationId: string]: Partial<ConversationTask> };
  setCreatedTasks: (
    conversationId: string,
    value: Partial<ConversationTask>,
  ) => void;
  removeCreatedTask: (conversationId: string) => void;
  hasNewTask: (
    conversationId?: string,
  ) => Partial<ConversationTask> | undefined;
}

export const useNewTaskStore = create(
  persist<NewTaskStore>(
    (set, getState) => ({
      createdTasks: {},
      setCreatedTasks: (conversationId, value) =>
        set((state) => ({
          createdTasks: { ...state.createdTasks, [conversationId]: value },
        })),
      removeCreatedTask: (conversationId) => {
        set((state) => {
          const { [conversationId]: _, ...rest } = state.createdTasks;
          return { createdTasks: rest };
        });
      },
      hasNewTask: (conversationId?: string) => {
        if (conversationId) {
          return getState().createdTasks[conversationId] || undefined;
        }
        return undefined;
      },
    }),
    {
      name: "new-task-storage",
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
